<template>
    <div id='show_sign'>
        <!-- 分享 -->
        <div class="gengduo_sing " @click="sing_show" style='width: .93rem; height: .93rem; border-radius: 0.5rem; background: #FFF;display: flex;align-items: center;justify-content: center;position: fixed;bottom: 1.5rem;left: 0.3rem; box-shadow: 0 0 2px 2px rgb(0 0 0 / 5%); z-index: 99;'>
            <img src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/images/shoer_index.png" style="width: .42rem;height: .42rem"></img>
        </div>
            
        <div class='shore_hreimg ' style='position: fixed; z-index: 999999;background: rgba(0, 0, 0, 1);width: 100%; height: 100%;top: 0px;display: none;'>
            <img src='' style='max-width:100%; max-height: 90%;    position: absolute;top: 0rem;right: 0;left: 0; margin: auto;'/>
            <p style='position: absolute;bottom: 0.3rem;right: 0;left: 0;width: 90%;background: rgba(255, 255, 255, 0.3);border-radius: 2rem;margin: auto;padding:  0.2rem;color: rgba(255, 255, 255, .8);text-align: center;'>长按保存图片</p>
        </div>

        <!-- 普通分享 -->
        <div class='wewah_share' v-show="show_data" style='display: none;'>
            <div class='wewah_share_back' @click="show_data = false"></div>
            <div class='wewah_share_pop'> 
                <div class="wewah_share_pop_bottom">
                    <div class="wewah_share_pop_flex">
                        <div class="wewah_share_pop_flex_copy" @click="copy"><img src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/share/icon_03.png" /> <p>复制链接</p></div>
                        <div @click="download"><img src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/share/icon_04.png" /> <p>分享海报</p></div>
                        <div @click="share_wexing = true"><img src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/share/icon_05.png" /> <p>分享页面</p></div>
                    </div>

                    <div class="wewah_share_pop_clone" @click="show_data = false">取消</div>
                </div>
            </div>
        </div>
        <input id='copy-input' class="" readOnly style="display: none;"/>

        <!-- 分享页面 -->
        <div class='share_wexing' v-show="share_wexing" @click="share_wexing = false" style='display: none;'>
            <img src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/share/share_html.png">
        </div>
        <div class='shower_href ' style='display: none;'>
            <div class='shower_href_body'>
                <img src='https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/images/shoer_href_04.png' />
                <div class='shower_href_bodys' style="width: 4.6rem;">
                    <h4>{{currentURL}}</h4>
                    <img src='https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/images/shoer_href_02.png'>
                    <p>新百易网校平台</p>
                    <div class='shower_href_bodys_img'>
                        <img src='https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/images/shoer_href_01.png' />
                    </div>
                    <div class="is_buy_box_ewma">
                        <div class="img"><canvas width="100" height="100"></canvas></div>
                        <p class='shoer_pone' >①保存图片到相册</p>
                        <p class='shoer_pone'>②长按二维码扫码可见</p>
                        <p class='shoer_ptwo' style='display: none;'>长按即可识别二维码</p>
                    </div>
                </div>
            </div>

            <div class="shower_href_quxiao" style=''>
                <span>取消</span>
            </div>
        </div>

        <div class="share_poster_Cimg shore_hreimgs" style='display: none;' @click="shore_hreimgs = false" v-show="shore_hreimgs">
            <img src="" />
            <p class='share_poster_code_tingsi' >长按保存图片，点击退出</p>
        </div>
    </div>
</template>

<script>
var thats;
import Clipboard from 'clipboard';
export default {
  name: "sortTable",
  props: {
    Mykey: {
    },
  },
  data() {
    return {
        show_data: false,
        share_url: '',
        share_wexing: false,
        shore_hreimgs: false,
        currentURL: '',
    };
  },

  watch: {
        "share_wexing":function(vla) {
            if(vla == true) {
                thats.show_data = false
            }
        },
        "shore_hreimgs":function(vla) {
            if(vla == true) {
                thats.show_data = false
            }
        }
  },
    mounted() {
        this.currentURL = document.title;
    },
  created() {
    thats = this
    setTimeout(function() {
        thats.share_url = window.location.href;
        var shaxr_url = window.location.origin
        $.get(shaxr_url + "/m/getshareurl", {share_url:  thats.share_url }, function (result) {
            if (result.code == 1) {
                thats.share_url = result.data
                thats.outputQRCod(thats.share_url, 100, 100);
            }
        });
    }, 1000)
  },
  methods:{
    sing_show() {
        this.show_data = true
    },
    copy() {
        var input1 = document.createElement("input");   // 直接构建input
        // input1.value = thats.share_url;  // 设置内容
        // document.body.appendChild(input1)
        // input1.select();   // 选择实例内容
        // document.execCommand("Copy");   // 执行复制
        // layer.msg('复制成功')

        let clipboard = new Clipboard('.wewah_share_pop_flex_copy', {
            text() {
                return thats.share_url;
            }
        })

        clipboard.on("success", ()=> {
            layer.msg('复制成功')
        })

        clipboard.on('error', () => {
            console.log('复制失败');
            // 清理，防止多次触发
            clipboard.destroy();
        });
    },
    download() {
        $('.shower_href').show()
        html2canvas(document.querySelector('.shower_href_body'), {
            x: $('.shower_href').offset().left,
            y: $('.shower_href_body').offset().top,
            useCORS: true,
            allowTaint: true,
            dpi: window.devicePixelRatio * 2
        }).then(canvas => {
            // console.log(canvas.toDataURL())
            $('.shore_hreimgs img').attr('src', canvas.toDataURL())
            // $('.shore_hreimgs').show()
            $('.shower_href').hide()
            thats.shore_hreimgs = true
        });
    },
    outputQRCod(text, width, height) {
        //先清空
        $(".is_buy_box_ewma .img").empty();
        //中文格式转换
        var str = thats.toUtf8(text);
        console.log(str)
        //生成二维码
        $(".is_buy_box_ewma .img").qrcode({
            render: "canvas",//canvas和table两种渲染方式
            width: width,
            height: height,
            text: str
        });
    },
    toUtf8(str) {
        var out, i, len, c;
        out = "";
        len = str.length;
        for (i = 0; i < len; i++) {
            c = str.charCodeAt(i);
            if ((c >= 0x0001) && (c <= 0x007F)) {
                out += str.charAt(i);
            } else if (c > 0x07FF) {
                out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
                out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
                out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
            } else {
                out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
                out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
            }
        }
        return out;
    }
  }
};

$('.Share_with_s_btns, .Share_with_s_sing_back').on('click',function() {
    $('.Share_with_s').hide()
})
</script>

<style  scoped>
    .Share_with_s_sing_img_bkc h4 {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>